import { render, staticRenderFns } from "./Serve.vue?vue&type=template&id=715a60a4&scoped=true&"
import script from "./Serve.vue?vue&type=script&lang=js&"
export * from "./Serve.vue?vue&type=script&lang=js&"
import style0 from "./Serve.vue?vue&type=style&index=0&id=715a60a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715a60a4",
  null
  
)

export default component.exports